@if (personFlagType$() | async; as personFlagType) {
  @if (currentIcon$() | async; as currentIcon) {
    <nk-flag-icon
      style="vertical-align: middle"
      [title]="'person_flag_type.' + personFlagType.person_flag_type_key | translate"
      [appIcon]="currentIcon"
      [size]="size()"
      [andClass]="andClass()"
      [colorClassOverride]="colorClassOverride()"></nk-flag-icon>
    @if (verbose()) {
      @if (personFlagEntity()?.flag_url) {
        <a class="d-inline-block ms-1" [href]="personFlagEntity()!.flag_url" target="_blank">
          {{ 'person_flag_type.' + personFlagType.person_flag_type_key | translate }}
        </a>
      } @else {
        {{ 'person_flag_type.' + personFlagType.person_flag_type_key | translate }}
      }
    }
  }
} @else {
  <nk-spinner display="inline"></nk-spinner>
}
